const makeHistory = (base, variance = 0.16, count = 28) =>
  Array.from({ length: count }, (_, index) => {
    const wave = Math.sin(index * 0.72) * variance;
    const step = Math.cos(index * 0.31) * variance * 0.5;
    return Math.max(0, Math.round(base * (1 + wave + step)));
  });

export const tankConfigs = [
  {
    id: "T-101",
    product: "Diesel",
    type: "vertical-open",
    capacityLiters: 9_000_000,
    volumeLiters: 6_524_000,
    minDispensableLiters: 450_000,
    redZoneLiters: 900_000,
    warningLiters: 2_500_000,
    location: "Depot North",
    status: "normal",
    inletLpm: 420,
    pumps: [
      {
        id: "P-101A",
        role: "Transfer Pump",
        status: "running",
        nominalFlowLpm: 650,
        flowRateLpm: 650,
        pressureBar: 5.2,
        runtimeSeconds: 74_676,
        totalDispensedLiters: 1_245_600,
        history: makeHistory(650),
      },
      {
        id: "P-101B",
        role: "Transfer Pump",
        status: "running",
        nominalFlowLpm: 375,
        flowRateLpm: 375,
        pressureBar: 4.8,
        runtimeSeconds: 40_632,
        totalDispensedLiters: 812_450,
        history: makeHistory(375, 0.12),
      },
      {
        id: "P-101C",
        role: "Standby Pump",
        status: "stopped",
        nominalFlowLpm: 540,
        flowRateLpm: 0,
        pressureBar: 0,
        runtimeSeconds: 0,
        totalDispensedLiters: 0,
        history: makeHistory(0),
      },
    ],
  },
  {
    id: "T-102",
    product: "Petrol",
    type: "vertical-open",
    capacityLiters: 6_500_000,
    volumeLiters: 2_934_000,
    minDispensableLiters: 520_000,
    redZoneLiters: 650_000,
    warningLiters: 3_000_000,
    location: "Depot North",
    status: "warning",
    inletLpm: 0,
    pumps: [
      {
        id: "P-102A",
        role: "Loading Pump",
        status: "warning",
        nominalFlowLpm: 420,
        flowRateLpm: 318,
        pressureBar: 3.7,
        runtimeSeconds: 23_912,
        totalDispensedLiters: 602_120,
        history: makeHistory(318, 0.22),
      },
      {
        id: "P-102B",
        role: "Transfer Pump",
        status: "running",
        nominalFlowLpm: 360,
        flowRateLpm: 360,
        pressureBar: 4.1,
        runtimeSeconds: 18_224,
        totalDispensedLiters: 391_700,
        history: makeHistory(360, 0.1),
      },
    ],
  },
  {
    id: "T-103",
    product: "Jet A-1",
    type: "vertical-open",
    capacityLiters: 5_200_000,
    volumeLiters: 421_000,
    minDispensableLiters: 312_000,
    redZoneLiters: 520_000,
    warningLiters: 1_250_000,
    location: "Depot East",
    status: "critical",
    inletLpm: 0,
    pumps: [
      {
        id: "P-103A",
        role: "Transfer Pump",
        status: "stopped",
        nominalFlowLpm: 300,
        flowRateLpm: 0,
        pressureBar: 0,
        runtimeSeconds: 13_040,
        totalDispensedLiters: 217_880,
        history: makeHistory(0),
      },
    ],
  },
  {
    id: "T-104",
    product: "Fuel Oil",
    type: "vertical-open",
    capacityLiters: 4_800_000,
    volumeLiters: 4_224_000,
    minDispensableLiters: 240_000,
    redZoneLiters: 480_000,
    warningLiters: 1_200_000,
    location: "Depot North",
    status: "normal",
    inletLpm: 180,
    pumps: [
      {
        id: "P-104A",
        role: "Booster Pump",
        status: "running",
        nominalFlowLpm: 280,
        flowRateLpm: 282,
        pressureBar: 5.8,
        runtimeSeconds: 59_312,
        totalDispensedLiters: 1_038_240,
        history: makeHistory(282, 0.08),
      },
    ],
  },
  {
    id: "HT-201",
    product: "Diesel",
    type: "horizontal-cylinder",
    capacityLiters: 2_700_000,
    volumeLiters: 1_819_000,
    minDispensableLiters: 180_000,
    redZoneLiters: 270_000,
    warningLiters: 760_000,
    location: "Depot West",
    status: "normal",
    inletLpm: 0,
    pumps: [
      {
        id: "P-201A",
        role: "Truck Loading Pump",
        status: "running",
        nominalFlowLpm: 240,
        flowRateLpm: 236,
        pressureBar: 4.3,
        runtimeSeconds: 31_744,
        totalDispensedLiters: 448_900,
        history: makeHistory(236, 0.15),
      },
      {
        id: "P-201B",
        role: "Recirculation Pump",
        status: "running",
        nominalFlowLpm: 95,
        flowRateLpm: 94,
        pressureBar: 2.1,
        runtimeSeconds: 81_909,
        totalDispensedLiters: 193_440,
        history: makeHistory(94, 0.1),
      },
    ],
  },
  {
    id: "HT-202",
    product: "Kerosene",
    type: "horizontal-cylinder",
    capacityLiters: 2_050_000,
    volumeLiters: 574_000,
    minDispensableLiters: 164_000,
    redZoneLiters: 205_000,
    warningLiters: 650_000,
    location: "Depot West",
    status: "warning",
    inletLpm: 0,
    pumps: [
      {
        id: "P-202A",
        role: "Issue Pump",
        status: "warning",
        nominalFlowLpm: 185,
        flowRateLpm: 118,
        pressureBar: 2.9,
        runtimeSeconds: 12_608,
        totalDispensedLiters: 120_330,
        history: makeHistory(118, 0.28),
      },
    ],
  },
];
